import { render, staticRenderFns } from "./FragmentSidebar.vue?vue&type=template&id=44cae2b4&"
import script from "./FragmentSidebar.vue?vue&type=script&lang=ts&"
export * from "./FragmentSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports